<div class="relative flex size-full flex-col justify-end">
  <wk8-pipe-back class="absolute top-0 left-0 size-full translate-x-[14%] -translate-y-[17.5%] scale-76 rotate-90" />
  <wk8-pipe-front class="absolute top-0 left-0 size-full translate-x-[14%] -translate-y-[15%] scale-80 rotate-90" />
  <!-- Tube -->
  <img class="tube absolute -top-[3%] left-[4%] h-[30%] w-[23%] scale-90" src="assets/woordkr8/sprites/tube.png" />
  <div
    #screen
    class="relative flex size-full h-3/4 items-center justify-between rounded-[9%] rounded-b-none border pt-[4%] pr-[3%] pb-[6%] pl-[3%] shadow"
    [style.border-left-width.px]="borderLeftPixels()"
    [style.border-right-wdith.px]="borderRightPixels()"
    [style.border-top-width.px]="borderTopPixels()"
    [style.border-bottom-width.px]="borderBottomPixels()"
    style="background-color: hsl(212, 6%, 48%); border-color: hsl(207, 5%, 65%)"
  >
    <!-- Screen content -->
    <div class="size-full overflow-clip rounded-[9%]">
      <ng-content></ng-content>
    </div>
  </div>
</div>
